import { render, staticRenderFns } from "./digitalHumanAppearance.vue?vue&type=template&id=27d25410&scoped=true"
import script from "./digitalHumanAppearance.vue?vue&type=script&lang=js"
export * from "./digitalHumanAppearance.vue?vue&type=script&lang=js"
import style0 from "./digitalHumanAppearance.vue?vue&type=style&index=0&id=27d25410&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d25410",
  null
  
)

export default component.exports